import { createEffect, createEvent, createStore } from 'effector'
import { ORDER_API } from '../api/order'

export const orderActions = {
  update: createEvent('update order'),
  end: createEvent('end order'),
  reset: createEvent('reset order'),
}

export const fetchOrder = createEffect('fetchOrder', {
  async handler({ orderNumber, transactionNumber, captchaToken }) {
    return await ORDER_API.fetch(orderNumber, transactionNumber, captchaToken)
  },
})

export const orderStore = createStore(null)
  .on(orderActions.update, (state, newState) => Object.assign({}, newState))
  .on(orderActions.end, (state, type) => ({ ...state, ended: { type } }))
  .on(fetchOrder.doneData, (state, newState) => Object.assign({}, newState))
  .reset(orderActions.reset)
